@if (recert) {
  <div  class="modal-header">
    <h5 class="modal-title">Find Recert 4473</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
}
<div class="modal-body">
  @if (recert) {
    <div>
      <!-- First Name Initial -->
      <div class="form-group" style="display: inline-block">
        <label class="bold" style="width: 150px">First Name Initial:</label>
        <input
          class="form-control"
          type="text"
          id="name_first_iniital"
          [(ngModel)]="name_first_initial"
          maxlength="1"
          pattern="[A-Za-z]"
          (input)="onNameFirstInitialInput($event); no_match = false"
          style="width: 150px"
          />
        </div>
        <!-- Last Name -->
        <div class="form-group" style="display: inline-block">
          <label class="bold" style="width: 200px">Last Name:</label>
          <input
            class="form-control"
            type="text"
            id="name_last"
            [(ngModel)]="name_last"
            (input)="no_match = false"
            style="width: 200px"
            />
          </div>
          <!-- Birth Date -->
          <div class="form-group" style="display: inline-block; width: 180px">
            <label class="bold" style="width: 175px">Birth Date:</label>
            <input
              #date_acquired="bsDatepicker"
              type="text"
              class="form-control text-uppercase input"
              id="birth_date"
              style="width: 175px"
              placeholder="MM/DD/YYYY"
              [bsConfig]="bsConfig"
              maxlength="10"
              minlength="10"
              [(ngModel)]="birthdate"
              [readOnly]="false"
              bsDatepicker
              autocomplete="off"
              appDateFormat
              (input)="no_match = false"
              />
              <i
                class="fa-solid fa-calendar icon_inside_input"
                (click)="date_acquired.show()"
                style="cursor: pointer"
              ></i>
            </div>
            <!-- Buttons -->
            <div style="display: inline-block; margin-left:15px">
              <!-- Submit Button -->
              <button
                class="btn btn-primary"
                style="width: 75px; margin-right: 25px; margin-bottom: 10px"
                (click)="FindPendingDisposition()"
                [disabled]="!isBirthdateValid() ||  !name_last || !name_first_initial"
                >
                Submit
              </button>
              <!-- Cancel Button -->
              <button
                class="btn btn-secondary"
                style="width: 75px; margin-right: 15px; margin-bottom: 10px"
                (click)="cancel()"
                >
                Cancel
              </button>
            </div>
            @if (no_match) {
              <alert type="warning" style="text-align: center;">
                *** No pending 4473 form found. Please re-check values or ask for assistance. ***
              </alert>
            }
          </div>
        }
        @if (!recert) {
          <div class="col text-center" style="margin-bottom: -20px">
            <button
              class="btn btn-primary mr-5 float-start"
              style="width: 200px; margin-left: 25px; margin-bottom: 10px"
              (click)="reCert4473()"
              >
              Recertify of 4473
            </button>
            <button
              class="btn btn-primary ml-5 float-end"
              style="width: 200px; margin-right: 25px; margin-bottom: 10px"
              (click)="fillOut4473()"
              >
              Fill Out 4473
            </button>
          </div>
        }
      </div>
